import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-3 pt-0"
}
const _hoisted_2 = { class: "overflow-auto" }
const _hoisted_3 = { class: "table table-striped border-light align-middle text-left position-relative" }
const _hoisted_4 = { class: "text-capitalize-first" }
const _hoisted_5 = { class: "text-capitalize-first" }
const _hoisted_6 = { class: "text-capitalize-first" }
const _hoisted_7 = { class: "text-capitalize-first" }
const _hoisted_8 = { class: "text-capitalize-first" }
const _hoisted_9 = { class: "text-capitalize-first" }
const _hoisted_10 = { class: "text-capitalize-first" }
const _hoisted_11 = { class: "text-capitalize-first" }
const _hoisted_12 = ["title"]
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_15 = { class: "text-end" }
const _hoisted_16 = { class: "d-flex gap-2 justify-content-end align-items-center" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { key: 0 }
const _hoisted_20 = {
  colspan: "9",
  class: "text-center text-muted py-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!
  const _component_b_modal = _resolveComponent("b-modal")!
  const _component_ConfirmModal = _resolveComponent("ConfirmModal")!
  const _component_ReattachRequisiteModal = _resolveComponent("ReattachRequisiteModal")!
  const _directive_b_tooltip = _resolveDirective("b-tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_b_modal, {
      title: _ctx.helper.trans('labels.counterparty_statistics'),
      "dialog-class": "modal-xl",
      modelValue: _ctx.isVisible,
      "footer-class": "d-flex justify-content-end",
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.isVisible = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_LoaderWrapper, {
          ref: "loader",
          class: "h-100"
        }, {
          default: _withCtx(() => [
            (_ctx.requisitesId)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("table", _hoisted_3, [
                      _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", _hoisted_4, _toDisplayString(_ctx.helper.trans('labels.user_id')), 1),
                          _createElementVNode("th", _hoisted_5, _toDisplayString(_ctx.helper.trans('labels.use_count')), 1),
                          _createElementVNode("th", _hoisted_6, _toDisplayString(_ctx.helper.trans('labels.completed_count')), 1),
                          _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.helper.trans('labels.conversion_rate')), 1),
                          _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.helper.trans('labels.average_check')), 1),
                          _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.helper.trans('labels.days_since_last_use')), 1),
                          _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.helper.trans('labels.first_used_at')), 1),
                          _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.helper.trans('labels.last_used_at')), 1),
                          _cache[2] || (_cache[2] = _createElementVNode("th", null, null, -1))
                        ])
                      ]),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.counterparties, (item, index) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: index,
                            class: ""
                          }, [
                            _createElementVNode("td", null, [
                              _withDirectives((_openBlock(), _createElementBlock("span", {
                                title: item.userId
                              }, [
                                _createTextVNode(_toDisplayString(item.userId.substring(0, 8)) + "...", 1)
                              ], 8, _hoisted_12)), [
                                [
                                  _directive_b_tooltip,
                                  void 0,
                                  void 0,
                                  { hover: true }
                                ]
                              ])
                            ]),
                            _createElementVNode("td", null, _toDisplayString(_ctx.numberFormatter.formatNumber(item.useCount)), 1),
                            _createElementVNode("td", null, _toDisplayString(_ctx.numberFormatter.formatNumber(item.completedCount)), 1),
                            _createElementVNode("td", null, _toDisplayString(_ctx.numberFormatter.formatNumber(item.conversionRate, 2)) + "%", 1),
                            _createElementVNode("td", null, _toDisplayString(_ctx.numberFormatter.formatNumber(Number.parseFloat(item.averageCheck), 2)), 1),
                            _createElementVNode("td", null, _toDisplayString(_ctx.numberFormatter.formatNumber(item.daysSinceLastUse)), 1),
                            _createElementVNode("td", null, [
                              (item.firstUsedAt)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.dateHelper.format(item.firstUsedAt, 'YYYY-MM-DD')), 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_14, "-"))
                            ]),
                            _createElementVNode("td", null, _toDisplayString(_ctx.dateHelper.format(item.lastUsedAt, 'YYYY-MM-DD')), 1),
                            _createElementVNode("td", _hoisted_15, [
                              _createElementVNode("div", _hoisted_16, [
                                _createElementVNode("button", {
                                  type: "button",
                                  onClick: ($event: any) => (_ctx.handleReattachClick(item.userId)),
                                  class: "btn btn-sm btn-outline-primary text-nowrap text-capitalize-first"
                                }, _toDisplayString(_ctx.helper.trans('button.reattach')), 9, _hoisted_17),
                                _createElementVNode("button", {
                                  type: "button",
                                  onClick: ($event: any) => (_ctx.confirmDeleteCounterparty(item.userId)),
                                  class: "btn btn-sm btn-outline-danger text-nowrap text-capitalize-first"
                                }, _toDisplayString(_ctx.helper.trans('button.unlink')), 9, _hoisted_18)
                              ])
                            ])
                          ]))
                        }), 128)),
                        (_ctx.counterparties.length === 0)
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_19, [
                              _createElementVNode("td", _hoisted_20, _toDisplayString(_ctx.helper.trans('labels.no_history')), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 512)
      ]),
      footer: _withCtx(() => [
        _createElementVNode("button", {
          type: "button",
          onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args)), ["prevent"])),
          class: "btn btn-outline-dark btn-sm text-capitalize-first"
        }, _toDisplayString(_ctx.helper.trans('button.ok')), 1)
      ]),
      _: 1
    }, 8, ["title", "modelValue"]),
    _createVNode(_component_ConfirmModal, { ref: "confirmModal" }, null, 512),
    _createVNode(_component_ReattachRequisiteModal, {
      ref: "reattachModal",
      onSelected: _ctx.handleReattach
    }, null, 8, ["onSelected"])
  ], 64))
}